import LangEnum from '../../../../lang/LangEnum';

export const LIVE_LABELS = [
  LangEnum.RACHEL_REASONING_LIVE_1,
  LangEnum.RACHEL_REASONING_LIVE_2,
  LangEnum.RACHEL_REASONING_LIVE_3,
  LangEnum.RACHEL_REASONING_LIVE_4,
  LangEnum.RACHEL_REASONING_LIVE_5,
  LangEnum.RACHEL_REASONING_LIVE_6,
  LangEnum.RACHEL_REASONING_LIVE_7,
  LangEnum.RACHEL_REASONING_LIVE_8,
  LangEnum.RACHEL_REASONING_LIVE_9,
  LangEnum.RACHEL_REASONING_LIVE_10,
];

export const pickLiveLabel = (seed: string): LangEnum => {
  let hash = 0;
  for (let index = 0; index < seed.length; index += 1) {
    hash = (hash * 31 + seed.charCodeAt(index)) | 0;
  }
  return LIVE_LABELS[Math.abs(hash) % LIVE_LABELS.length];
};
